import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import {
  getSearchListMovies,
} from '../../services/categories.service';
import { getLocalValue } from '../../utils/local-cache.util';
import { LS_ADMIN_USER_ID } from '../../config/const.config';

const SearchableContent = ({
  id,
  name,
  label,
  defaultValue,
  multiple,
  disabled,
  onChange,
  sx,
  error,
}) => {
  const selectedValue = defaultValue || (multiple ? [] : null);

  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    // for feature and playlist category assignment
    const adminUserId = getLocalValue(LS_ADMIN_USER_ID);
      getSearchListMovies(adminUserId)
        .then((res) => {
          setOptions(res?.data || []);
          setValue(defaultValue);
        })
        .catch(() => {
          // upon error, show loading only
        });
    
  }, [defaultValue]);

  return (
    <Autocomplete
      id={id}
      name={name}
      options={options}
      getOptionLabel={(option) => `${option.title}`}
      sx={sx}
      value={value}
      onChange={(e, v) => {
        setValue(v);
        onChange(v);
      }}
      inputValue={inputValue}
      onInputChange={(e, v) => {
        setInputValue(v);
      }}
      multiple={multiple}
      disabled={disabled}
      // loading={loading}
      isOptionEqualToValue={(op, vl) => op.id === vl.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error !== ''}
          helperText={error}
          variant="filled"
        />
      )}
      renderOption={(props, option) => (
        <li
          {...props}
          style={{ color: option.status === 0 ? 'grey' : 'inherit' }}
        >
          {option.title}
        </li>
      )}
    />
  );
};

SearchableContent.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  loadOption: PropTypes.func.isRequired,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  dataId: PropTypes.number,
};
SearchableContent.defaultProps = {
  multiple: false,
  disabled: false,
  sx: {},
  defaultValue: null,
  error: '',
  dataId: null,
};

export default SearchableContent;
